import React from 'react'
import ImageNotAvailable from '../../../assets/image-not-available.png'
import CustomImage from 'src/components/customImage/customImage'
import { isEmpty } from 'lodash'
import OptionsBtn from '../../../assets/elipsis-icon.svg'

const RecordingCard = ({
  cardStyle = {},
  cardClass = '',
  cardImage = '',
  textData = [],
  actionButtonOptions = [],
  cardImgWidth = '10%',
  actionButtonWidth = '5%',
  statusWidth = '12%',
  disableStatus = false,
  disableCardImg = false,
  status = false,
  statusCallback = () => {},
  // cardOnClick = () => {},
}) => {
  return (
    <div
      style={{
        width: '100%',
        aspectRatio: '1506/71',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        display: 'flex',
        background: '#ececec',
        ...cardStyle,
      }}
      className={`rounded-1 ${cardClass}`}
      tabIndex={0}
    >
      {!disableCardImg && (
        <div
          className="relative rounded-lg mx-2 d-flex justify-content-center align-items-center p-1"
          style={{ height: '100%', width: cardImgWidth }}
        >
          <CustomImage
            className="card-img-top w-auto h-auto"
            imageUrl={cardImage}
            loaderStyle={{ height: '100%' }}
            errorPlaceholder={ImageNotAvailable}
            alt={'Asset'}
            imgStyle={{
              opacity: '1',
              pointerEvents: 'all',
              maxHeight: '2.9vw',
              maxWidth: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      )}

      <div
        className="d-flex  align-items-center"
        style={{
          background: 'none',
          width: `calc(100% - ${cardImgWidth})`,
        }}
      >
        <div style={{ fontSize: '12px' }} className="d-flex  align-items-center w-100">
          {textData.map((info, idx) => (
            <p
              style={{
                marginBlockEnd: '0',
                background: 'none',
                textOverflow: 'ellipsis',
                paddingLeft: '1.5px',
                ...info.styles,
              }}
              key={idx}
              className="line-clamp-2"
            >
              {info?.name}
            </p>
          ))}
          {!disableStatus && (
            <div
              className="mx- d-flex justify-content-between align-items-center rounded-1 overflow-hidden"
              style={{ border: '0.5px solid #707070', width: statusWidth }}
            >
              <div
                className="d-flex justify-content-center align-items-center w-50"
                style={{
                  height: '1.5625vw',
                  backgroundColor: status ? '#000' : '#fff',
                  color: status ? '#fff' : '#000',
                  fontSize: '12px',
                  cursor: 'pointer',
                }}
                onClick={() => statusCallback(true)}
              >
                <p
                  style={{
                    marginBlock: '0',
                    fontWeight: status ? '600' : '400',
                  }}
                >
                  Enable
                </p>
              </div>
              <div
                className="d-flex justify-content-center align-items-center w-50"
                style={{
                  height: '1.5625vw',
                  color: status ? '#000' : '#fff',
                  backgroundColor: status ? '#fff' : '#000',
                  fontSize: '12px',
                  cursor: 'pointer',
                }}
                onClick={() => statusCallback(false)}
              >
                <p
                  style={{
                    marginBlock: '0',
                    fontWeight: status ? '400' : '600',
                  }}
                >
                  Disable
                </p>
              </div>
            </div>
          )}

          {!isEmpty(actionButtonOptions) && (
            <div
              style={{
                width: actionButtonWidth,
                fontSize: '20px',
                fontWeight: '700',
                cursor: 'pointer',
              }}
              className="d-flex justify-content-center align-items-center position-relative preview-menu-dots"
            >
              <button style={{ border: 'none', outline: 'none', background: 'none' }}>
                <img src={OptionsBtn} alt="OptionsBtn" />
              </button>
              <div
                className="position-absolute preview-menu-button dropdown-menu-btn-position border"
                tabIndex={0}
              >
                {actionButtonOptions.map((info, idx) => (
                  <div
                    key={idx}
                    style={{ cursor: 'pointer', fontSize: '12px', padding: '0ch 2ch' }}
                    className="d-flex hover:bg-slate-100"
                    onClick={() => {
                      info?.btnFunction()
                    }}
                  >
                    {info?.logo ? info?.logo : null}
                    {info?.name}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RecordingCard
